/**
 * @returns {Object}
 */
export function rtl() {

    return {
        restrict: 'A',
        link: (scope, element, attr) => {

            scope.$watch(attr.rtl, (value) => {

                element[ value ? 'attr' : 'removeAttr' ]('dir', 'rtl');
            });
        }
    };
}

rtl.$inject = [];


// WEBPACK FOOTER //
// ./src/ui/directives/rtl.directive.js